import 'remixicon/fonts/remixicon.css';
import React from 'react';
import { useAppSelector } from '../../store/Hooks';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';

export interface UserInfoModalProps {
    close: () => void;
}

function UserInfoModal(props: UserInfoModalProps) {

    const studentData: StudentData = useAppSelector(state => state.studentData)
    const teacherData: TeacherData = useAppSelector(state => state.teacherData)
    const user = teacherData.isAuthenticated ? teacherData.teacher : studentData.student;
    let username = user.username !== undefined ? user.username : "kirjautumaton käyttäjä";
    //this should be identification instead of username

    const [fullname, setFullName] = React.useState(username);
    const [email, setEmail] = React.useState('');

    const handleChange = (event: any) => {
        switch (event.target.name) {
            case "email": {
                setEmail(event.target.value);;
                break;
            }
            case "fullname": {
                setFullName(event.target.value);
                break;
            }
            default: {
                break;
            }
        }
    }

    const handleSubmit = (event: any) => {
       //TODO
    }

    let form: JSX.Element = (

        <form className="">
            <div className="mb-6">
                <div className="mb-2">
                    <label className="text-gray-500 font-bold">
                        Vanha salasana
                    </label>
                </div>
                <input className="
                    w-96 bg-gray-200 appearance-none 
                    border-2 border-gray-200 
                    rounded text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"
                    id="fullname"
                    name="fullname"
                    type="text"
                    placeholder="nimi"
                    value={fullname}
                    onChange={handleChange} />
            </div>
            <div>
                <div className="mb-2">
                    <label className="text-gray-500 font-bold mb-2">
                        Sähköposti
                    </label>
                </div>
                <input className="
                    w-96 bg-gray-20 appearance-none 
                    border-2 border-gray-200 rounded
                    text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"
                    id="email"
                    name="email"
                    type="text"
                    placeholder="@"
                    value={email}
                    onChange={handleChange} />
            </div>
            <div className="">
                <div className="mt-4">
                    <button onClick={handleSubmit} className="border-transparent text-sm font-medium rounded-md text-white border-transparent bg-teal-600 hover:bg-teal-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500" type="button">
                        Tallenna
                    </button>
                    <button onClick={props.close} className="ml-2 border-transparent text-sm font-medium rounded-md text-white border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" type="button">
                        Peruuta
                    </button>
                </div>
            </div>
        </form>
    );

    return (
        <div className="w-96 m-8">
            <h2 className="mt-6 mb-6 text-center text-2xl font-extrabold text-gray-900">Muokkaa tietoja</h2>
            <div>{form}</div>
        </div>
    );
}

export default UserInfoModal